function onApplyFinanceClick() {
    console.log("GA STARTED");
    ga('send', 'event', 'PDP Financing Drawer', 'click', 'FinanceClick', {
      'hitCallback': function() {
        document.location = 'https://www.davivienda.com/wps/portal/personas/nuevo#6cf69528-bd3a-46c7-bfd6-a66d69ee8896';
      }
    });
  
  }
  
  function onApplyFinanceStickyBar(){
    ga('send', 'event', 'Apply Financing - PDP Sticky Bar', 'click', 'FinanceClick', {
      'hitCallback': function() {
        document.location = 'https://www.davivienda.com/wps/portal/personas/nuevo#6cf69528-bd3a-46c7-bfd6-a66d69ee8896';
      }
    });
  }